import { useLayoutEffect } from "react";
import { adjustHeight } from "./domHelper";

// Updates the height of a <textarea> when the value changes.
const useAutosizeTextArea = (
  textAreaRef: HTMLTextAreaElement | null,
  value?: string | number | null
) => {
  useLayoutEffect(() => {
    adjustHeight(textAreaRef);
  }, [textAreaRef, value]);
};

export default useAutosizeTextArea;